import {HttpClient} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-email-composer',
    templateUrl: './email-composer.component.html',
})
export class EmailComposerComponent implements OnInit {

    public html = '';
    public preview = false;

    constructor(
        private _http: HttpClient,
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Email', instructions: ['/email']}).add('Email küldés');
    }

    togglePreview() {
        this.preview = !this.preview;
    }

    send() {
        console.log('TODO');
        // this._http.put(environment.backend + '/api/email/send', {html: this.html}).subscribe(
        //     console.log,
        //     console.error
        // );
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-composer/email-composer.component.ts